exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#bsh-tab button[data-v-3a2f2f2a]{background-color:#fff}.cl-blue[data-v-3a2f2f2a]{color:#00f}.nowrap[data-v-3a2f2f2a]{white-space:nowrap}.dropdown-toggle[data-v-3a2f2f2a]:after{display:none}", ""]);

// exports
